import React from "react";
import connectImg from "../assets/connect-systems.png";


export default function IntegrationMap() {
  return (
    <section id="integration" className="section" style={{ background: "var(--navy-deep)" }}>
      <div className="container">
        <div className="row mb-2">
          <div className="col-lg-12">
            <div className="eyebrow mb-3">How integration actually works</div>
            <h2 className="display-font text-white mb-3" style={{ fontSize: "2.2rem", fontWeight: 600 }}>
              One architecture, every system you already run
            </h2>
            <p style={{ color: "rgba(255,255,255,0.68)", maxWidth: 600, lineHeight: 1.7 }}>
              Instead of replacing what works, we build the connective layer:
              APIs, middleware, and data pipelines that let your CRM, ERP,
              legacy databases, and customer-facing apps speak the same
              language.
            </p>
          </div>
          
            <div className="col-lg-12 mt-3">
              <img
                src={connectImg}
                alt="GAPNIX connecting your CRM, cloud, ERP and APIs"
                className="img-fluid"
              />
            </div>
        </div>

       
      </div>
    </section>
  );
}
